import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import { LatestQuestionFragmentDoc } from './LatestQuestion.fragment.queries'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type AuditReportFragment = {
  __typename?: 'Case'
  id: number
  answerIsOverdue: boolean
  lastTransitionAt?: any | null
  customer: {
    __typename?: 'Customer'
    id: number
    firstName?: string | null
    lastName?: string | null
    latestQuestion?: {
      __typename?: 'Message'
      id: number
      type: Types.MessageType
      appointmentAt?: any | null
      approvedAt?: any | null
      letterRequest?: {
        __typename?: 'LetterRequest'
        id: number
        powerOfAttorney?: { __typename?: 'PowerOfAttorney'; uid: string } | null
      } | null
      topic: { __typename?: 'Topic'; id: number; name: string }
    } | null
    membership?: {
      __typename?: 'Membership'
      uuid: string
      membershipType: { __typename?: 'MembershipType'; uid: string; displayName: string }
    } | null
    note?: { __typename?: 'CustomerNote'; id: number; note: string } | null
  }
  purchase: {
    __typename?: 'Purchase'
    id: number
    product?: { __typename?: 'Product'; id: number; name: string } | null
  }
}

export type AuditReportsQueryVariables = Types.Exact<{
  filters: Types.CasesListFilterInput
  sorts?: Types.InputMaybe<Types.CasesListSortInput>
  pagination?: Types.InputMaybe<Types.PaginationInput>
}>

export type AuditReportsQuery = {
  __typename?: 'Query'
  cases: {
    __typename?: 'CasesCollection'
    total: number
    items: Array<{
      __typename?: 'Case'
      id: number
      answerIsOverdue: boolean
      lastTransitionAt?: any | null
      customer: {
        __typename?: 'Customer'
        id: number
        firstName?: string | null
        lastName?: string | null
        latestQuestion?: {
          __typename?: 'Message'
          id: number
          type: Types.MessageType
          appointmentAt?: any | null
          approvedAt?: any | null
          letterRequest?: {
            __typename?: 'LetterRequest'
            id: number
            powerOfAttorney?: { __typename?: 'PowerOfAttorney'; uid: string } | null
          } | null
          topic: { __typename?: 'Topic'; id: number; name: string }
        } | null
        membership?: {
          __typename?: 'Membership'
          uuid: string
          membershipType: { __typename?: 'MembershipType'; uid: string; displayName: string }
        } | null
        note?: { __typename?: 'CustomerNote'; id: number; note: string } | null
      }
      purchase: {
        __typename?: 'Purchase'
        id: number
        product?: { __typename?: 'Product'; id: number; name: string } | null
      }
    }>
  }
}

export const AuditReportFragmentDoc = gql`
  fragment AuditReport on Case {
    id
    answerIsOverdue
    lastTransitionAt
    customer {
      id
      firstName
      lastName
      latestQuestion {
        ...LatestQuestion
      }
      membership {
        uuid
        membershipType {
          uid
          displayName
        }
      }
      note {
        id
        note
      }
    }
    purchase {
      id
      product {
        id
        name
      }
    }
  }
  ${LatestQuestionFragmentDoc}
`
export const AuditReportsDocument = gql`
  query AuditReports(
    $filters: CasesListFilterInput!
    $sorts: CasesListSortInput
    $pagination: PaginationInput
  ) {
    cases(filters: $filters, sorts: $sorts, pagination: $pagination) {
      items {
        ...AuditReport
      }
      total
    }
  }
  ${AuditReportFragmentDoc}
`
export function useAuditReportsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<AuditReportsQuery, AuditReportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<AuditReportsQuery, AuditReportsQueryVariables>(
    AuditReportsDocument,
    options
  )
}
export function useAuditReportsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuditReportsQuery, AuditReportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<AuditReportsQuery, AuditReportsQueryVariables>(
    AuditReportsDocument,
    options
  )
}
export type AuditReportsQueryHookResult = ReturnType<typeof useAuditReportsQuery>
export type AuditReportsLazyQueryHookResult = ReturnType<typeof useAuditReportsLazyQuery>
export type AuditReportsQueryResult = ApolloReactCommon.QueryResult<
  AuditReportsQuery,
  AuditReportsQueryVariables
>
export function refetchAuditReportsQuery(variables?: AuditReportsQueryVariables) {
  return { query: AuditReportsDocument, variables: variables }
}
